/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type DeleteGooseGameQuestMutationVariables = Types.Exact<{
  id: Types.Scalars["Float"];
}>;

export type DeleteGooseGameQuestMutation = {
  deleteGooseGameQuest: Pick<Types.GooseGameQuest, "id" | "title">;
};

export const DeleteGooseGameQuestDocument = gql`
  mutation DeleteGooseGameQuest($id: Float!) {
    deleteGooseGameQuest(id: $id) {
      id
      title
    }
  }
`;

/**
 * __useDeleteGooseGameQuestMutation__
 *
 * To run a mutation, you first call `useDeleteGooseGameQuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGooseGameQuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGooseGameQuestMutation, { data, loading, error }] = useDeleteGooseGameQuestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGooseGameQuestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteGooseGameQuestMutation,
    DeleteGooseGameQuestMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    DeleteGooseGameQuestMutation,
    DeleteGooseGameQuestMutationVariables
  >(DeleteGooseGameQuestDocument, baseOptions);
}
export type DeleteGooseGameQuestMutationHookResult = ReturnType<
  typeof useDeleteGooseGameQuestMutation
>;
export type DeleteGooseGameQuestMutationResult =
  ApolloReactCommon.MutationResult<DeleteGooseGameQuestMutation>;
export type DeleteGooseGameQuestMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteGooseGameQuestMutation,
    DeleteGooseGameQuestMutationVariables
  >;
